import React from "react";
import aboutImg1 from "../assets/img/about1.svg";
import aboutImg2 from "../assets/img/about2.svg";
import Heading from "./small-component/Heading";

export default function About() {
  return (
    <div>
      <section id="about" className="container">
        <Heading title="About" />
        <div className="row justify-content-center">
          <div className="col-xl-5 col-md-6 order-md-1 order-1">
            <p className="font-italic">
              Aligator IT Solutions are founded as a software development
              startup in 2020 by young generation group. Our team giving
              technical & data solution for manage the enterprises and make easy
              to handle their work. We recognize that adhering to the highest
              level of conduct in serving clients worldwide and acting with
              integrity at all times is of utmost importance.Our Mission are
              delivering the best-suited technology services and solutions to
              empower our clients to realize their business goals.
            </p>

            
          </div>
          <div className="col-xl-5 col-md-6 order-md-2 order-2">
            <img src={aboutImg1} className="img-fluid" alt="" />
          </div>
        </div>
        <div className="row justify-content-center mt-5">
        <div className="col-xl-5 col-md-6 order-md-1 order-2">
            <img src={aboutImg2} className="img-fluid about-imgn" alt="" />
          </div>
          <div className="col-xl-5 col-md-6 order-md-2 order-1">
          <h5 className="">
              <i>Why choose Aligator IT Solutions ?</i>
            </h5>

          

            <ul>
              <li>
                <i className="icofont-check-circled"></i>Responding quickly,
                making swift decisions
              </li>
              <li>
                <i className="icofont-check-circled"></i>Our promise of
                customer-centricity through actions and deliverables, even if it
                means going an extra mile.
              </li>
              <li>
                <i className="icofont-check-circled"></i>Building relationships
                with our clients, colleagues, and partners with trust, respect,
                and sharing.
              </li>
              <li>
                <i className="icofont-check-circled"></i>Upholding honesty,
                truthfulness, sincerity, and always honoring the trust of our
                clients.
              </li>
              <li>
                <i className="icofont-check-circled"></i>Communicating openly
                and honestly with our clients
              </li>
              <li>
                <i className="icofont-check-circled"></i>We never let down our
                clients.
              </li>
              <li>
                <i className="icofont-check-circled"></i>We Commit 99.99%
                Accuracy
              </li>
            </ul>
          </div>
          
        </div>
      </section>
      <section id="counter" className="counter-section">
        <div className="container">
          <div className="row text-center">
            <div className="col-md-3 col-6 ">
              <span data-toggle="counter-up">2</span>
              <p>Clients</p>
            </div>
            <div className="col-md-3 col-6">
              <span data-toggle="counter-up">4</span>
              <p>Projects</p>
            </div>
            <div className="col-md-3 col-6">
              <span data-toggle="counter-up">168</span>
              <p>Hours Of Support</p>
            </div>
            <div className="col-md-3 col-6">
              <span data-toggle="counter-up">3</span>
              <p>Hard Workers</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
